import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { Input, Select } from '../reusable';

const O2OEventOptions = [
  { label: '', value: undefined },
  { label: 'BOPIS', value: 'SaleForPickup' },
  { label: 'SFS', value: 'SaleForDelivery' },
  { label: 'DSIS', value: 'digitalSalesInStore' }
];

const OtherInformation = ({ fields, handleChange }) => {
  const { localizedBody } = useSelector((state) => state);
  return (
    <section className="ncss-col-sm-11 ncss-col-lg-10 border mb2-sm">
      <header className="ncss-row">
        <p className="headline-2 text-color-primary-light bg-black ta-sm-l pl2-sm">{localizedBody.RL_Other}</p>
      </header>
      <article className="ncss-col-sm-12 ncss-col-md-11 ncss-col-lg-10 ncss-col-xl-8 p4-sm ta-sm-l">
        <section className="ncss-row">
          <Input
            label={localizedBody.RL_TransactionUUID}
            value={fields.transactionUUID}
            onChange={(value) => handleChange('transactionUUID', value)}
          />
          {(fields.transactionType === 'RetailTransaction' || fields.transactionType === 'Return') && (
          <Select
            label={localizedBody.RL_O2OEvents}
            options={O2OEventOptions}
            value={fields.o2oEvents}
            zIndex={5}
            onChange={(value) => handleChange('o2oEvents', value)}
          />
          )}
          <Input
            label={localizedBody.RL_TextSearch}
            value={fields.freeText}
            onChange={(value) => handleChange('freeText', value)}
          />
        </section>
      </article>
    </section>
  );
};

OtherInformation.propTypes = {
  fields: PropTypes.shape().isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default OtherInformation;
